import React from "react";
import BusinessDetailsComponent from "./BusinessDetailsComponent";
import AssignRepresentativeComponent from "./AssignRepresentativeComponent";
import AssignRepresentativeComponentV2 from "./AssignRepresentativeComponentV2";
import BusinessDetailsComponentV3 from "./BusinessDetailsComponentV3";
import NIBiddingApplicationForm from "./NIBiddingApplicationForm";
import BidApplicationFormWithOutPD from "./IndividualBidders/BidApplicationFormWithOutPD";
import NIDeclarationComponent from "./NIDeclarationComponent";
import NITermsAndConditions from "./NITermsAndConditions";
import BidderBidApplicationDownloadComponent from "./IndividualBidders/BidderBidApplicationDownloadComponent";
import ApproverDetailsForm from "./IndividualBidders/ApproverDetailsForm";
import NICompletedComponent from "./NICompletedComponent";

interface NonIndividualOfflineKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
  enableUpdatedKyc: boolean;
  requiresApproverDetails?: boolean;
}

export default function NonIndividualOfflineKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
  enableUpdatedKyc,
  requiresApproverDetails = true,
}: NonIndividualOfflineKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return enableUpdatedKyc ? (
          <BusinessDetailsComponentV3
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        ) : (
          <BusinessDetailsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 1:
        return enableUpdatedKyc ? (
          <AssignRepresentativeComponentV2
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        ) : (
          <AssignRepresentativeComponent
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 2:
        return offlinePaymentValidation ? (
          <BidApplicationFormWithOutPD
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
          />
        ) : (
          <NIBiddingApplicationForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="bid_details"
            hideHeader={true}
          />
        );
      case 3:
        return (
          <NIDeclarationComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            init={init}
            outerNextStep="ar_declaration"
          />
        );
      case 4:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="t_&_c"
          />
        );
      case 5:
        return (
          <BidderBidApplicationDownloadComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep={
              requiresApproverDetails ? "bid_application_download" : "completed"
            }
            requiresApproverDetails={requiresApproverDetails}
          />
        );
      case 6:
        return requiresApproverDetails ? (
          <ApproverDetailsForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        ) : (
          <NICompletedComponent bidderUuid={bidderUuid} />
        );
      case 7:
        return <NICompletedComponent bidderUuid={bidderUuid} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {activeStep !== 2 && (
        <div className="flex flex-col sm:flex-row justify-end gap-2">
          <div className="flex items-center flex-wrap text-[10px] sm:text-xs">
            <span className="text-brand-orange font-semibold">Offline KYC</span>
            <span className="text-gray-500 font-semibold pl-1">
              → Final bid application must be submitted at the bank.
            </span>
          </div>
        </div>
      )}
      {renderStepContent()}
    </div>
  );
}
